export default {
  container: (overflowY = 'auto', overflowX = 'hidden') => ({
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '100%',
    height: '100%',
    justifyContent: 'space-between',
    overflowY,
    overflowX
  })
};